import { IconType } from 'react-icons/lib';
import { Icon } from '@nbirl/nbi-common-ui-libs';
import classNames from 'classnames';

import { SidebarLink } from '../../../../shared/components';

type DashboardsSidebarLinkProps = {
  path: string;
  title: string;
  isSelected: boolean;
  icon: IconType;
};

export const DashboardsSidebarLink = ({
  path,
  title,
  isSelected,
  icon: DashboardIcon,
}: DashboardsSidebarLinkProps) => (
  <SidebarLink path={path}>
    <Icon
      icon={
        <DashboardIcon
          className={classNames('flex-none text-xl text-primary-200', {
            'text-primary-500': isSelected,
          })}
        />
      }
    />
    <span
      className={classNames({
        'text-primary-500': isSelected,
      })}
    >
      {title}
    </span>
  </SidebarLink>
);
